import React, { useEffect, useState } from "react";
import styles from "./styles.module.scss";
import { Avatar, Button, Input, message, Modal, Spin, Tooltip } from "antd";
import { SearchOutlined, TagFilled } from "@ant-design/icons";
import { Space, Table, Tag } from "antd";
import {
  CircleTickIcon,
  CompletedCaseStatus,
  CPUIcon,
  CreateCaseIcon,
  DeleteIcon,
  DeleteIconRed,
  EmptyCircleIcon,
  Error,
  PendingCaseStatus,
  Tick,
  UploadFileIcon,
  ViewDetailsIcon,
} from "icons";
import { Link, useNavigate, useParams } from "react-router-dom";
import { UseApiCallV2, useDebounce, UseLazyApiCallV2 } from "hooks";
import { UseApiCallForOldDashboardData } from "hooks/use-api-call-for-old-dashboard";
import { dateTimeFormatted, getDatatableWidth } from "utils/helpers";
import moment from "moment";
import { useLanguageTranslator } from "hooks/use-language-translator";
import { ExtractedDataModal } from "../extractedDataModal";
import { clientMasterData, formFields } from "pages/cases-detail/constants";
import { caseStatus } from "store/atom";
import { useRecoilState } from "recoil";

export const AllUploadedFiles = ({
  refetchDetail,
  legalDocuments,
  isLoading,
  refetchAllUploadedFiles,
  refetchLegalDocs,
  collapseOpen,
  tableHeading,
  refetchCount,
}) => {
  const { translator } = useLanguageTranslator();
  const legalDocsValuesTrans = translator("caseDetail.legalDocs");
  const allUploadedValuesTrans = translator("caseDetail.allUploadedFiles");
  const [openUploadFileModal, setOpenUploadFileModal] = useState(false);
  const [queries, setQueries] = useState([]);
  const [selectedDocument, setSelectedDocument] = useState({});
  const navigate = useNavigate();
  const [openExtractedDetail, setOpenExtractedDetails] = useState(false);
  const [selectedFile, setselectedFile] = useState(null);

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [userSearch, setUserSearch] = useState("");
  const [selectedRecord, setSelectedRecord] = useState({});
  const deboucedSearch = useDebounce(userSearch, 500);
  const [caseStatusOpenOrClosed, setCaseStatusOpenOrClosed] =
    useRecoilState(caseStatus);

  const { caseId } = useParams();
  const [
    deleteUploadedFile,
    {
      data: deleteUploadedFileData,
      isLoading: deleteUploadedFileLoading,
      error: deleteUploadedFileError,
    },
  ] = UseLazyApiCallV2({
    url: "/delete_file",
    method: "POST",
  });
  const [
    getScannedDoc,
    {
      data: scannedData,
      isLoading: scannedDataLoading,
      error: scannedDataError,
    },
  ] = UseLazyApiCallV2({
    url: "/get_scanned_document",
    method: "POST",
  });
  async function handleClickDelete(item) {
    const params = {
      case_id: caseId,
      documentType: item?.documentType,
      fileName: item?.fileName,
      id: item?.id,
    };

    try {
      const res = await deleteUploadedFile({
        params,
      });
      if (res?.status === "Success") {
        message.success(res?.message);
        // await refetchUploaded();
        await refetchAllUploadedFiles();
        await refetchLegalDocs();
        await refetchCount();
      }
    } catch (error) {
      message.error(translator("somethingWentWrong"));
    }
  }

  const columns = [
    {
      title: legalDocsValuesTrans.key,
      dataIndex: "key",
      key: "key",
      render: (text, record, index) => {
        return index + 1;
      },
      width: "8%",
      align: "left",
    },
    {
      title: legalDocsValuesTrans.fileName,
      dataIndex: "fileName",
      key: "fileName",
      width: "20%",
      align: "left",
      ellipsis: true,
      sorter: (a, b) => a.fileName.localeCompare(b.fileName),
    },
    {
      title: legalDocsValuesTrans.name,
      dataIndex: "documentType",
      key: "documentType",
      width: "20%",
      align: "left",

      sorter: (a, b) => a.documentType.localeCompare(b.documentType),

      render: (value, record) => {
        return legalDocsValuesTrans[value];
      },
    },
    {
      title: allUploadedValuesTrans.uploadedAt,
      dataIndex: "uploadedAt",
      key: "uploadedAt",
      width: "17%",
      align: "left",
      sorter: (a, b) => {
        const timeA =
          a.uploadedAt === "None" ? 0 : moment(a.uploadedAt).valueOf();
        const timeB =
          b.uploadedAt === "None" ? 0 : moment(b.uploadedAt).valueOf();
        return timeA - timeB; // oldest → latest, click again for reverse
      },
      render: (value, record) => {
        return value !== "None" ? dateTimeFormatted(value) : "";
      },
    },
    {
      title: allUploadedValuesTrans.uploadedBy,
      dataIndex: "uploadedByName",
      key: "uploadedByName",
      width: "20%",
      ellipsis: true,
      align: "center",
      sorter: (a, b) => a.uploadedByName.localeCompare(b.uploadedByName),
      render: (value, record) => {
        return value === "None" ? "" : value;
      },
    },

    {
      title: legalDocsValuesTrans.action,
      key: "action",
      width: "14%",
      align: "center",
      render: (_, record) => {
        const isUploaded = !!record.isUploaded;

        return (
          <Space size="small">
            <button
              className={styles.viewDetailsBtn}
              onClick={() => onViewClick(record)}
            >
              <img
                src="/assets/icons/eye.svg"
                alt="Icon"
                height={15}
                width={15}
              />
            </button>
            <button
              className={`${styles.viewDetailsBtn} ${
                caseStatusOpenOrClosed === "closed" ? styles.disabledBtn : ""
              }`}
              onClick={() => handleClickDelete(record)}
            >
              <DeleteIconRed style={{ height: "15px", width: "15px" }} />
            </button>
          </Space>
        );
      },
    },
  ];

  const [studioFinalData, setStudioFinalData] = useState([
    1, 2, 3, 4, 5, 6, 7, 8, 9, 10,
  ]);

  function filterFieldsByApiDataWithChildAnswers(
    totalFields,
    apiData,
    dropdownsListObj = {},
  ) {
    if (!totalFields || !apiData) return [];

    const apiKeys = new Set(Object.keys(apiData));

    return totalFields
      .map((field) => {
        // Parent field: keep only sections that have childs present in apiData
        if (field.isParent && Array.isArray(field.sections)) {
          const filteredSections = field.sections
            .map((section) => {
              const filteredChilds = (section.childs || [])
                .filter(
                  (child) =>
                    apiKeys.has(child.key) &&
                    apiData[child.key] != null &&
                    apiData[child.key] !== "",
                ) // keep only childs present in API
                .map((child) => ({
                  // keep original child properties but add Answer/Query/checked/dropdownList
                  ...child,
                  Answer: apiData[child.key],
                  Query: child.key,
                  checked: true,
                  dropdownList: dropdownsListObj[child.key] || [],
                }));

              return filteredChilds.length > 0
                ? { ...section, childs: filteredChilds }
                : null;
            })
            .filter(Boolean);

          // Keep parent only if parent key exists in API OR it has at least one matching child
          if (apiKeys.has(field.key) || filteredSections.length > 0) {
            return {
              ...field,
              Answer: apiData[field.key],
              Query: field.key,
              checked: !!apiData[field.key],
              sections: filteredSections,
            };
          }

          return null; // drop parent completely if no relevant keys
        }

        // Non-parent standalone field: keep only if present in API
        if (
          apiKeys.has(field.key) &&
          apiData[field.key] != null &&
          apiData[field.key] !== ""
        ) {
          return {
            ...field,
            Answer: apiData[field.key],
            Query: field.key,
            checked: true,
            dropdownList: dropdownsListObj[field.key] || [],
          };
        }

        return null; // drop if not in API
      })
      .filter(Boolean);
  }

  function handleCloseExtractedDetails() {
    setOpenExtractedDetails(false);
  }
  async function onViewClick(record) {
    setOpenExtractedDetails(true);
    setselectedFile({ ...record });
    const params = {
      case_id: record?.caseId,
      documentType: record?.documentType,
    };
    const res = await getScannedDoc({
      params,
    });
    const arrOfObjects = filterFieldsByApiDataWithChildAnswers(
      [...formFields, ...clientMasterData],
      res?.data,
    );
    if (!arrOfObjects) return;
    setQueries([...arrOfObjects]);
  }
  const totalData = Array(20)
    .fill(0)
    ?.map((item, index) => {
      return {
        key: index + 1,
        filename: `2025-254-AS12`,
        updatedBy: "Anna Müller",
        lastUpdated: "2025-08-14 08:01:48",
        numberOfFiles: "3",
        status: "completed",
      };
    });
  useEffect(() => {
    const filteredData = totalData?.filter((item) =>
      item.username?.toLowerCase()?.includes(deboucedSearch),
    );
    setStudioFinalData(filteredData);
  }, [deboucedSearch]);

  function handleChatSearch(e) {
    const searchedKey = e.target?.value?.toLowerCase();
    const filteredData = totalData.filter((item) =>
      item.username.toLowerCase().includes(searchedKey),
    );
    setStudioFinalData(filteredData);
  }
  function openCreateLicense() {
    navigate("/create-case");
  }
  function handleCloseModal() {
    setOpenUploadFileModal(false);
  }

  return (
    <div className={styles.tableContainer}>
      <div className={styles.tableWrapper}>
        <Spin spinning={isLoading || deleteUploadedFileLoading}>
          <Table
            columns={columns}
            dataSource={legalDocuments}
            rowClassName={styles.row}
            scroll={{
              y: collapseOpen ? `calc(100dvh - 500px)` : `calc(100dvh - 310px)`,
            }}
            style={{ width: "100%", minHeight: "calc(100dvh - 180px)" }}
            className={styles.userListTable}
            sticky={true}
            // pagination={{
            //   position: ["bottomCenter"],
            //   // pageSize: pageSize,
            //   // current: currentPage,
            // }}
            pagination={false}
            title={() => tableHeading}
          />
        </Spin>
      </div>
      <ExtractedDataModal
        handleCloseModal={handleCloseExtractedDetails}
        open={openExtractedDetail}
        queries={queries}
        setQueries={setQueries}
        documentType={selectedFile?.documentType}
        fileName={selectedFile?.fileName}
        refetchDetail={refetchDetail}
        allowUpdate={false}
      />
    </div>
  );
};
